import React, { useEffect, useState } from 'react';

import { useTheme } from '@material-ui/styles';

import { ChooseCategories, ChooseFirstPlayer, ChooseLanguage, ChooseMode, ChooseTeams } from '../SetUp';
import { Hexagon } from '../';

export const SetUp = ({game}) => {

  const [currentStep, setCurrentStep] = useState(0);
  const [mode, setMode] = useState(0);
  const [role, setRole] = useState("ER");
  const [categories, setCategories] = useState(new Set());
  const [lecture, setLecture] = useState([]);
  const [teams, setTeams] = useState([]);
  const [firstPlayer, setFirstPlayer] = useState(null);

  const theme = useTheme();

  // Scroll to top when step changes
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [currentStep])


  const changeStep = {
    forward: () => setCurrentStep(currentStep + 1),
    backward: () => setCurrentStep(currentStep - 1),
    custom: (newStepIndex) => setCurrentStep(newStepIndex)
  }


  // Collect data for game set up and pass it to game
  const finishSetUp = () => {
    game.startGame(mode, role, categories, lecture, teams, firstPlayer)
  }


  const steps = [
    {
      component: <ChooseLanguage changeStep={changeStep} />
    },
    {
      component: <ChooseMode changeStep={changeStep} mode={mode} role={role}  setMode={setMode} setRole={setRole} />
    },
    {
      component: <ChooseCategories changeStep={changeStep} mode={mode} categories={categories} setCategories={setCategories} setLecture={setLecture} />
    },
    {
      component: <ChooseTeams changeStep={changeStep} teams={teams} setTeams={setTeams} />
    },
    {
      component: <ChooseFirstPlayer finishSetUp={finishSetUp} firstPlayer={firstPlayer} setFirstPlayer={setFirstPlayer} teams={teams} mode={mode} />
    },
  ];

  const getStepComponent = () => {
    return steps[currentStep].component;
  }

  return (
    <div className="set-up">
      
      {/* Logo */}
      {/* 
        * @todo
        * logo big for first screen
       */}
      <a href={process.env.PUBLIC_URL} className="set-up__logo" style={currentStep === 0 ? null :{width: "26.5rem"}}>
        <img src={`${process.env.PUBLIC_URL}/assets/images/logos/logo-set-up.png`} alt="HAZWOPER CHALLENGE" />
      </a>

      {/* Step nav */}
      <nav className="set-up__nav">
        <ol>
          {steps.map( (step, i) => {
            const active = i === currentStep;
            return (
              <li key={i} className={`hexagon ${active ? ' active' : ''}`}>
              
                <Hexagon 
                  strokeWidth={2} 
                  fill={active ? theme.palette.redDark : theme.palette.navyDark3} 
                  stroke={active ? theme.palette.redDark : theme.palette.red}
                >
                  <span className="sr-only">Step </span>{i + 1}
                </Hexagon>
            

              </li>
            )
          })}
        </ol>
      </nav>

      {getStepComponent()}

    </div>
  )
}